import { ReactNode } from "react"

import Icon from "@/components/icon/Icon"
import { colors } from "@/components/colors"

import "./settingSectionItem.scss"

export default function SettingSectionItem({
  children,
  onDeleteItem,
}: {
  children: ReactNode
  onDeleteItem?: () => void
}) {
  return (
    <div className="SettingSectionItemCont">
      {onDeleteItem && (
        <button onClick={onDeleteItem}>
          <Icon
            type="close"
            size={20}
            color={colors.neutral.grey[500]}
            className="setting-section-delete-icon"
          />
        </button>
      )}
      {children}
    </div>
  )
}
